var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation } from '@apollo/client/react';
import { t } from '@lingui/core/macro';
import { useToast } from '@pocketlaw/tetris';
import useAccount from 'shared/domains/users/hooks/useAccount';
import { activeAccount } from 'shared/domains/users/utils/activeAccount';
import { setupCompanyMutation } from './mutation';
export function useCreateCompany() {
    var _a;
    const userAccount = useAccount();
    const { addToast } = useToast();
    const userId = (_a = userAccount.data) === null || _a === void 0 ? void 0 : _a.userId;
    const [mutate, state] = useMutation(setupCompanyMutation);
    const waitFor = (ms) => __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(undefined);
            }, ms);
        });
    });
    const createCompany = (values) => __awaiter(this, void 0, void 0, function* () {
        var _b;
        const { companyName, marketCode } = values;
        addToast({
            title: t `Setting up account`,
            appearance: 'info',
        });
        const { data } = yield mutate({
            context: { withCompany: false },
            variables: {
                userId,
                companyName,
                companyMarketCode: marketCode,
            },
        });
        const account = data === null || data === void 0 ? void 0 : data.account;
        yield waitFor(2000);
        activeAccount.set((_b = account === null || account === void 0 ? void 0 : account.id) !== null && _b !== void 0 ? _b : '');
        addToast({
            title: t `Account created`,
            appearance: 'info',
        });
        yield waitFor(1000);
        return account;
    });
    return Object.assign({ createCompany }, state);
}
